/*
*
* File JS componente FAQ
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './faq.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const DURATION = 350;
const EASING = 'ease';

const faq = () =>
{
    document.querySelectorAll('.faq__items').forEach((list) =>
    {
        const items = Array.from(list.querySelectorAll('.faq__item'));

        const animate = (item, from, to, onEnd) =>
        {
            if (item._animation) item._animation.cancel();

            item.style.overflow = 'hidden';

            item._animation = item.animate(
                { height: [from + 'px', to + 'px'] },
                { duration: DURATION, easing: EASING }
            );

            const done = () =>
            {
                item._animation = null;
                item.style.overflow = '';
                onEnd();
            };

            item._animation.onfinish = done;
            item._animation.oncancel = () => { item._animation = null; item.style.overflow = ''; };
        };

        const open = (item) =>
        {
            const summary = item.querySelector('.faq__question');
            const answer = item.querySelector('.faq__answer');
            const from = item.offsetHeight;

            item.classList.add('is-open');
            item.open = true;

            animate(item, from, summary.offsetHeight + answer.offsetHeight, () => {});
        };

        const close = (item) =>
        {
            const summary = item.querySelector('.faq__question');
            const from = item.offsetHeight;

            item.classList.remove('is-open');

            animate(item, from, summary.offsetHeight, () => { item.open = false; });
        };

        items.forEach((item) =>
        {
            item.querySelector('.faq__question').addEventListener('click', (e) =>
            {
                e.preventDefault();

                if (item.classList.contains('is-open')) {
                    close(item);
                    return;
                }

                // accordion esclusivo: aprendone uno si chiudono gli altri
                items.forEach((other) =>
                {
                    if (other !== item && other.classList.contains('is-open')) close(other);
                });

                open(item);
            });
        });
    });
}

//--------------------------------------------------------------------//



// EXPORT COMPONENTE
//--------------------------------------------------------------------//

export default faq;

//--------------------------------------------------------------------//
